<template>
  <el-dialog title="活动班级管理" :visible.sync="modalShow">
    <el-form :model="searchForm" ref="searchForm" size="small" inline>
      <el-form-item label="产品名称" prop="spuName">
        <el-input v-model.trim="searchForm.spuName" placeholder="产品名称" />
      </el-form-item>
      <el-form-item label=" " label-width="100px">
        <el-button type="primary" @click="search('searchForm')">查询</el-button>
        <el-button @click="reset('searchForm')">重置</el-button>
      </el-form-item>
    </el-form>
    <div>
      <el-button type="primary" @click="action_fn(1)">添加</el-button>
    </div>
    <br>
    <el-table border stripe v-loading="loading" :data="tableData" style="width: 100%" ref="table">
      <el-table-column prop="index" label="序号" minWidth="160" align="center" :formatter="fliteRData">
        <template slot-scope="{row}">
          <template v-if="row.indexStatus">
            <el-input v-model.trim="row.sortNum" size="mini" class="input" maxlength="8"/>
            <el-button type="primary" size="mini" @click.stop="updateRow('index',row)">保存</el-button>
          </template>
          <template v-else>
            <span class="input">{{row.sortNum || '--'}}</span>
            <el-button type="primary" icon="el-icon-edit" size="mini" @click.stop="editeFn('index',row)"></el-button>
          </template>
        </template>
      </el-table-column>
      <el-table-column prop="spuName" label="产品名称" minWidth="250" align="center" :formatter="fliteRData"></el-table-column>
      <el-table-column prop="spuCode" label="产品代码" minWidth="160" align="center" :formatter="fliteRData"></el-table-column>
      <el-table-column prop="spuType" label="产品类型" minWidth="150" align="center">
        <template slot-scope="scope">
          <template v-if="scope.row.spuType == 1">班级</template>
          <template v-else-if="scope.row.spuType == 2">专题课</template>
          <template v-else-if="scope.row.spuType == 3">公开课</template>
          <template v-else-if="scope.row.spuType == 4">书籍</template>
          <template v-else-if="scope.row.spuType == 5">章节习题</template>
          <template v-else-if="scope.row.spuType == 6">试卷习题</template>
          <template v-else-if="scope.row.spuType == 7">题库</template>
          <template v-else-if="scope.row.spuType == 8">0元课</template>
          <template v-else>--</template>
        </template>
      </el-table-column>
      <el-table-column prop="skuName" label="班级名称" minWidth="160" align="center" :formatter="fliteRData"></el-table-column>
      <el-table-column prop="priceMin" label="班级底价" minWidth="150" align="center" :formatter="fliteRData"></el-table-column>
      <el-table-column prop="price" label="拼团价格" minWidth="160" align="center" :formatter="fliteRData">
        <template slot-scope="{row}">
          <template v-if="row.editeStatus">
            <el-input v-model.trim="row.price" size="mini" class="input" maxlength="8"/>
            <el-button type="primary" size="mini" @click.stop="updateRow('price',row)">保存</el-button>
          </template>
          <template v-else>
            <span class="input">{{row.price}}</span>
            <el-button type="primary" icon="el-icon-edit" size="mini" @click.stop="editeFn('price',row)"></el-button>
          </template>
        </template>
      </el-table-column>
      <el-table-column prop="spuType" label="是否为0元班" minWidth="160" align="center">
        <template slot-scope="scope">
          <template v-if="scope.row.price == 0">是</template>
          <template v-else>否</template>
        </template>
      </el-table-column>
      <el-table-column prop="className" label="绑定分类" minWidth="160" align="center" :formatter="fliteRData"></el-table-column>
      <el-table-column label="操作" minWidth="160" align="center" fixed="right">
        <template slot-scope="scope">
          <a class="blue_Box" @click="action_fn(2,scope.row)">绑定分类</a>
        </template>
      </el-table-column>
    </el-table>
    <br>
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="pageSizes" layout="total, sizes, prev, pager, next" :total="total" />
    <span slot="footer" class="dialog-footer"></span>
    <!-- 绑定分类列表 -->
    <classListData ref="classListData" />
    <!-- 添加活动产品 -->
    <addActProduct ref="addActProduct" :total="total" />
  </el-dialog>
</template>

<script>
import tableMoudel from "@/libs/mixin/table";

import classListData from "./classList.vue"
import addActProduct from "./addActProduct"

import { Admin } from "../api"

export default {
  mixins: [tableMoudel],
  components: { classListData, addActProduct },
  data () {
    return {
      modalShow: false,
      searchForm: {
        spuName: null
      },
      spId: null
    }
  },
  watch: {
    modalShow: {
      handler (value) { if (!value) { this.$refs['searchForm'].resetFields() } },
    }
  },
  mounted () {
    this.$bus.$on('update', res => {
      if (res) {
        this.getData()
      }
    })
  },
  methods: {
    init (spId) {
      this.modalShow = true
      this.spId = spId
      this.getData()
    },
    async getData () {
      const params = { ...this.searchForm, ...this.pageInfo }
      params.spId = this.spId
      const res = await Admin.classgetListPage(params)
      if (res.code !== 0) return
      const { records } = res.data
      this.tableData = records.map(item => {
        item.editeStatus = false
        item.indexStatus = false
        item.price = item.price ?? '--'
        return {
          ...item
        }
      })
      this.total = Number(res.data.total)
    },
    action_fn (type, item) {
      switch (type) {
        case 1:
          this.$refs.addActProduct.init(this.spId)
          break;
        case 2:
          this.$refs.classListData.init(item.id)
          break;
      }
    },
    editeFn (key, item) {
      switch (key) {
        case 'price':
          item.editeStatus = true
          break;
        case 'index':
          item.indexStatus = true
          break;
      }
    },
    async updateRow (key, item) {
      switch (key) {
        case 'price':
          let price = item.price
          if(typeof(price) == 'null' || typeof(price) == 'undefined' || price == ''){
            this.$message.warning('请输入拼团价格！')
            return
          }
          let params_price = {
            id: item.id,
            price: item.price
          }
          const res_price = await Admin.updateActivitySpSku(params_price)
          if (res_price.code !== 0) return
          this.$message.success('操作成功！')
          item.editeStatus = false
          this.$bus.$emit('update', true)
          this.getData()
          break;
        case 'index':
          let params_index = {
            id: item.id,
            sortNum: item.sortNum
          }
          const res_index = await Admin.updateActivitySpSku(params_index)
          if (res_index.code !== 0) return
          this.$message.success('操作成功！')
          item.indexStatus = false
          this.getData()
          break;
      }

    },
  }
}
</script>

<style scoped>
.input {
  width: 50%;
  margin-right: 8px;
}
</style>